<template>
  <v-row>
    <v-col cols="10">
      <p class="float-left">Applied Filters</p>

      <span v-for="(item, key) in photoFilter" :key="key">
          <v-chip v-if="key=='fromDt' && item != null " class="ma-2">
            Tagged From Date - {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='thruDt' && item != null " class="ma-2">
            Tagged Thru Date - {{ item }}
          </v-chip>

          <v-chip v-for="filter in item" v-else-if="key=='taggers'" :key="filter.id" class="ma-2">
            {{ filter.email }}
          </v-chip>

           <v-chip v-for="tag in item" v-else-if="key=='tags'" :key="tag.id" class="ma-2">
            {{ tag.full_name }}
          </v-chip>

          <v-chip v-for="project in item" v-else-if="key=='projects'" :key="project.id" class="ma-2">
            {{ project.name }}
          </v-chip>

          <v-chip v-for="job in item" v-else-if="key=='jobs'" :key="job.id" class="ma-2">
            {{ job.name }}
          </v-chip>

          <v-chip v-else-if="key=='onlyNeedsReview' && item==true" class="ma-2">
            Only Needs Review
          </v-chip>

        <v-chip v-else-if="key=='country' && item!=null"  class="ma-2">
            Country: {{ item }}
        </v-chip>

        <v-chip v-else-if="key=='retailer' && item!=null" class="ma-2">
            Retailer: {{ item }}
          </v-chip>

        <v-chip v-else-if="key=='department' && item!=null" class="ma-2">
            Department: {{ item }}

        </v-chip>

          <v-chip v-for="filter in item" v-else-if="key=='respIdSearchFreeForm'" :key="filter" class="ma-2">
            Response ID: {{ filter }}
          </v-chip>

          <v-chip v-else-if="key=='question_id' && item" class="ma-2">
            Question ID: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='rgidSearchFreeForm' && item" class="ma-2">
            Response Group ID: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='showQCed' && item==true" class="ma-2">
            Show QCed
          </v-chip>


        </span>

    </v-col>
    <v-col cols="2">
      <v-row>
        <v-col cols="3">
          <filter-btn :dialog="dialog" class="mr-0">
            <q-c-photo-filter-modal :departmentChoices="departments"
                                    :photoFilters="photoFilter"
                                    :retailerChoices="retailers"
                                    @apply-filters="applyFilters($event)"
                                    @dialog-clicked="handleDialogClicked($event)"
                                    @modal-mounted="dialog = true"
            />
          </filter-btn>
        </v-col>
        <v-col cols="9">
          <v-btn class="mr-0" color="primary" small @click="resetFilters">
            Reset Filters
          </v-btn>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import FilterBtn from '../btns/FilterBtn.vue'
import QCPhotoFilterModal from './QCPhotoFilterModal.vue'
import {mapState} from 'vuex'


export default {
  name: 'QCPhotoFilter',
  components: {
    QCPhotoFilterModal,
    FilterBtn
  },
  props: {
    initialFilter: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      retailers: [],
      departments: [],
      photoFilter: {
        fromDt: null,
        thruDt: null,
        tags: [],
        projects: [],
        jobs: [],
        taggers: [],
        respIdSearchFreeForm: null,
        rgidSearchFreeForm: null,
        question_id: null,
        onlyNeedsReview: false,
        showQCed: false,
        includeInactive: false,
        country: null,
        retailer: null
      }
    }
  },
  mounted() {
    this.get_retailer_list()
    this.get_department_list()
    this.photoFilter.fromDt = this.initialFilter.fromDt
    this.photoFilter.thruDt = this.initialFilter.thruDt
    this.photoFilter.tags = this.initialFilter.tags
    this.photoFilter.projects = this.initialFilter.projects
    this.photoFilter.jobs = this.initialFilter.jobs
    this.photoFilter.taggers = this.initialFilter.taggers
    this.photoFilter.respIdSearchFreeForm = this.initialFilter.respIdSearchFreeForm
    this.photoFilter.rgidSearchFreeForm = this.initialFilter.rgidSearchFreeForm
    this.photoFilter.question_id = this.initialFilter.question_id
    this.photoFilter.onlyNeedsReview = this.initialFilter.onlyNeedsReview
    this.photoFilter.showQCed = this.initialFilter.showQCed
    this.photoFilter.includeInactive = this.initialFilter.includeInactive === true
    this.photoFilter.country = this.initialFilter.country
    this.photoFilter.retailer = this.initialFilter.retailer
  },
  computed: {
    ...mapState({
      projects: state => state.photos.projects,
      jobs: state => state.photos.jobs,
      tags: state => state.tags.tags,

    })
  },
  watch: {},
  methods: {
    async get_retailer_list() {
      this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
        fields: [{'keys': ['loading_list'], 'value': 'get_retailer_list', action: 'toggle'},]
      });

      let new_this = this;
      return new Promise((resolve, reject) => {
        axios.get('/api/retailers').then(response => {
          let data = response.data;
          new_this.retailers = data;
          resolve(response.data);
        }).catch(e => {
          console.log(e);
          reject(e);
        }).finally(() => {
          new_this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
            fields: [{'keys': ['loading_list'], 'value': 'get_retailer_list', action: 'toggle'},]
          });
        });
      });
    },
    async get_department_list() {
      this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
        fields: [{'keys': ['loading_list'], 'value': 'get_department_list', action: 'toggle'},]
      });

      let new_this = this;
      return new Promise((resolve, reject) => {
        axios.get('/api/departments').then(response => {
          let data = response.data;
          new_this.departments = data;
          resolve(response.data);
        }).catch(e => {
          console.log(e);
          reject(e);
        }).finally(() => {
          new_this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
            fields: [{'keys': ['loading_list'], 'value': 'get_department_list', action: 'toggle'},]
          });
        });
      });
    },
    handleDialogClicked(val) {
      this.dialog = false
    },
    applyFilters(filterValues) {

      if (filterValues.fromDt != null) {
        this.photoFilter.fromDt = filterValues.fromDt
      } else {
        this.photoFilter.fromDt = null
      }

      if (filterValues.thruDt != null) {
        this.photoFilter.thruDt = filterValues.thruDt
      } else {
        this.photoFilter.thruDt = null
      }

      if (filterValues.tags) {
        this.photoFilter.tags = filterValues.tags
      } else {
        this.photoFilter.tags = []
      }

      if (filterValues.projects) {
        this.photoFilter.projects = filterValues.projects
      } else {
        this.photoFilter.projects = []
      }

      if (filterValues.jobs) {
        this.photoFilter.jobs = filterValues.jobs
      } else {
        this.photoFilter.jobs = []
      }

      if (filterValues.taggers) {
        this.photoFilter.taggers = filterValues.taggers
      } else {
        this.photoFilter.taggers = []
      }

      if (filterValues.respIdSearchFreeForm) {
        let string_this_way = filterValues.respIdSearchFreeForm
        this.photoFilter.respIdSearchFreeForm = string_this_way.match(/\d+/g)
      } else {
        this.photoFilter.respIdSearchFreeForm = null
      }

      if (filterValues.rgidSearchFreeForm) {
        this.photoFilter.rgidSearchFreeForm = filterValues.rgidSearchFreeForm
      } else {
        this.photoFilter.rgidSearchFreeForm = null
      }

      if (filterValues.question_id) {
        this.photoFilter.question_id = filterValues.question_id
      } else {
        this.photoFilter.question_id = null
      }

      this.photoFilter.onlyNeedsReview = filterValues.onlyNeedsReview
      this.photoFilter.showQCed = filterValues.showQCed
      this.photoFilter.includeInactive = filterValues.includeInactive === true
      this.photoFilter.country = filterValues.country
      this.photoFilter.retailer = filterValues.retailer
      this.photoFilter.department = filterValues.department

      this.dialog = false
      this.$emit('apply-filters', this.photoFilter)
    },
    resetFilters() {
      this.photoFilter.fromDt = null
      this.photoFilter.thruDt = null
      this.photoFilter.tags = []
      this.photoFilter.projects = []
      this.photoFilter.jobs = []
      this.photoFilter.taggers = []
      this.photoFilter.onlyNeedsReview = false
      this.photoFilter.showQCed = false
      this.photoFilter.includeInactive = false
      this.photoFilter.respIdSearchFreeForm = null
      this.photoFilter.rgidSearchFreeForm = null
      this.photoFilter.question_id = null
      this.photoFilter.country = null
      this.photoFilter.retailer = null
      this.photoFilter.department = null
      this.$emit('apply-filters', this.photoFilter)
    },

  }
}
</script>

<style>
</style>
